export default {
    tagged: '6.6.2-f0d7b52',
    version: '6.6.2',
    revision: 'f0d7b52',
};
//# sourceMappingURL=version.js.map